// GVSU republishes this page under a new year-stamped URL each year. The ISD Mid-Year and
// End of Year survey schemas stored in the database embed these URLs too and each needs a
// matching migration.
export const RCN_ANNUAL_ACTIVITIES_URL = 'https://www.gvsu.edu/autismcenter/rcn/2026-2027-annual-activities-11'
export const CETA_PDS_INSTRUCTIONS_URL = `${RCN_ANNUAL_ACTIVITIES_URL}#cetapds`
export const COACHING_CAPACITY_TOOL_INSTRUCTIONS_URL = `${RCN_ANNUAL_ACTIVITIES_URL}#coachingcapacitytool`
export const P2P_DATA_COLLECTION_INSTRUCTIONS_URL = `${RCN_ANNUAL_ACTIVITIES_URL}#p2pdatacollection`

export const EPLI_URL = 'https://www.gvsu.edu/autismcenter/start/epli-226'
export const EPLI_TRAINER_PORTAL_URL = 'https://www.gvsu.edu/autismcenter/start/epli-trainer-portal-57'
export const START_TRAININGS_URL = 'https://www.gvsu.edu/autismcenter/start/start-trainings-list-167'
export const PATHS_TO_LEARNING_URL = 'https://www.gvsu.edu/autismcenter/start/paths-to-learning-127'
export const START_COACHING_URL = 'https://www.gvsu.edu/autismcenter/start/start-coaching-220'
export const COMMUNITIES_OF_PRACTICE_URL = 'https://www.gvsu.edu/autismcenter/start/communities-of-practice-cop-119'
